import React from "react";
import ConfirmationPage, { StyledConfirmationHeader, StyledConfirmationText, StyledDetailWrapper, StyledConfirmationTextSpaced, } from "components/mobile_pay/views/confirmation_page";
import { StyledBoldText } from "components/mobile_pay/views/page";
export default function PaymentSuccessPage(_a) {
    var processedPaymentInfo = _a.processedPaymentInfo, checkInfo = _a.checkInfo, merchantInfo = _a.merchantInfo;
    return (React.createElement(ConfirmationPage, { merchantInfo: merchantInfo },
        React.createElement(StyledConfirmationHeader, null, "Thank you!"),
        React.createElement(StyledConfirmationText, null, "We let the restaurant know, so you can leave when you\u2019re ready."),
        React.createElement(StyledDetailWrapper, null,
            React.createElement(StyledConfirmationTextSpaced, null,
                "Total:",
                " ",
                React.createElement(StyledBoldText, null, processedPaymentInfo.payment.amount
                    .add(processedPaymentInfo.payment.tipAmount)
                    .format())),
            React.createElement(StyledConfirmationTextSpaced, null,
                "Payment Method:",
                " ",
                React.createElement(StyledBoldText, { style: { whiteSpace: "nowrap" } }, processedPaymentInfo.payment.tenderName)),
            React.createElement(StyledConfirmationTextSpaced, null,
                "Check #: ",
                React.createElement(StyledBoldText, null, checkInfo.checkNumber))),
        React.createElement(StyledConfirmationText, null, "We\u2019ll send an email receipt to " + processedPaymentInfo.email)));
}
